export const OPENCITY_BASE_URL = process.env.REACT_APP_OPENCITY_BASE_URL;

export const OPENCITY_JSONRPC_ENTRY_POINT = process.env.REACT_APP_OPENCITY_JSONRPC_ENTRY_POINT;

export const OPENCITY_TTK_PROXY_URL = process.env.REACT_APP_OPENCITY_TTK_PROXY_URL;
